import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

export const columns = [
  {
    title: '机构ID',
    slot: 'orgId',
    width: tableColumnsWidth.type4
  },
  {
    title: '机构ID',
    slot: 'orgName',
    width: tableColumnsWidth.type6
  },
  {
    title: '账户编号',
    slot: 'acctNo',
    width: tableColumnsWidth.type4
  },
  {
    title: '账户名称',
    slot: 'acctName',
    width: tableColumnsWidth.type6
  },
  {
    title: '监管银行',
    slot: 'inAcctType',
    width: tableColumnsWidth.type2
  },
  {
    title: '分账规则模板编号',
    key: 'configId',
    width: tableColumnsWidth.type4
  },
  {
    title: '分账规则模板名称',
    slot: 'configName',
    width: tableColumnsWidth.type6
  },
  {
    title: '分账规则状态',
    slot: 'enable',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '账期周期',
    slot: 'accountingType',
    width: tableColumnsWidth.type8
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: tableColumnsWidth.type4
  },
  {
    title: '操作人',
    key: 'operatorName',
    width: tableColumnsWidth.type2
  },
  {
    title: '操作时间',
    key: 'operatorTime',
    width: tableColumnsWidth.type4
  }
]
